module.exports = __webpack_public_path__ + "static/img/gongzhonghao.1ff36c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobiigw/gongzhonghao.png
// module id = nkYT
// module chunks = 1